module.exports = __webpack_public_path__ + "img/diff_scales.bb6bba29.png";